import { AbstractControl, ValidatorFn } from '@angular/forms';
import Swal from 'sweetalert2';

declare const moment: any;

export const CustomIsAMinor = (type: any): ValidatorFn => {
  const message = `This patient is a Minor, she/he must have a companion`;
  let age = 18;

  return (control: AbstractControl): any => {

    try {

      if (!control.value) {
        return null;
      }

      if (typeof type === 'string') {
        type = type.toLocaleLowerCase();
        type = type.split(',');
      }

      if (type[1]) {
        age = parseInt(type[1], 10);
      }

      if (moment().diff(control.value, 'years', false) < age) {

        if (type[0] === 'warning') {

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: true
          });

          Toast({
            type: 'warning',
            title: message
          }).then();
          return null;
        } else {
          return {
            invalidIsAMinor: true,
            message: message
          };
        }

      }
    } catch (error) {
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/components/is-a-minor/is-a-minor.validator.ts